import { useCallback, useState } from 'react';

export const useOpen = (init = false): [boolean, () => void, () => void, () => void] => {
  const [isOpen, setIsOpen] = useState(init);

  const handleOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  const handleToggleOpen = useCallback(() => {
    setIsOpen(open => !open);
  }, []);

  return [isOpen, handleOpen, handleClose, handleToggleOpen];
};
